import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@sama/app-state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Range } from '../../../../../cross-team-shared/types/misc';
import { AbstractViewSettingsSliderComponent } from '../abstract-view-settings-slider.component';

@Component({
  selector: 'h3-view-settings-range-slider',
  templateUrl: './view-settings-range-slider.component.html',
  styleUrl: './view-settings-range-slider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewSettingsRangeSliderComponent
  extends AbstractViewSettingsSliderComponent<Range>
  implements OnInit
{
  value$!: Observable<string>;
  minStore!: Store<number>;
  maxStore!: Store<number>;

  override ngOnInit() {
    super.ngOnInit();

    this.minStore = this.settingStore('min');
    this.maxStore = this.settingStore('max');
    this.value$ = this.settingStore.$.pipe(
      map(
        (range) =>
          `${this.formatValue(range.min)} ↔ ${this.formatValue(range.max)}`,
      ),
    );
  }

  setMinValue(event: Event) {
    const target = event.target as HTMLInputElement;
    let value = target.valueAsNumber;
    if (value === this.maxStore.state()) {
      value = this.maxStore.state() - this.config.step;
    }
    super.setValueAndTrackEvent(value, this.settingStore('min'));
  }

  setMaxValue(event: Event) {
    const target = event.target as HTMLInputElement;
    let value = target.valueAsNumber;
    if (value === this.minStore.state()) {
      value = this.minStore.state() + this.config.step;
    }
    super.setValueAndTrackEvent(value, this.settingStore('max'));
  }
}
